import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'zone.js';
import { registerStableFileUpload } from './app/shared/helper/formio-file-upload-fix';
import 'moment/min/locales.js';

if (environment.production) {
  enableProdMode();
}

registerStableFileUpload();

platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
  if ('serviceWorker' in navigator && environment.production) {
    navigator.serviceWorker.register('./ngsw-worker.js').then(() => {
      // Ignored
    });
  }
})
  .catch(err => console.error(err));

